import React from 'react';

import './DiscountProgramIntro.scss';
import sendEvent from '../../helpers/tracking';
import { setItem } from '../../helpers/localStorage';

export default function DiscountProgramIntro(props) {
  return (
    <section className="discountProgramIntro">
      <div className="discountProgramIntro_buttons_box_mobile">
        <div
          className="discountProgramIntro_button"
          onClick={() => handleClick()}
        >
          Lid worden
        </div>

        <div
          className="discountProgramIntro_button"
          onClick={() => scrollPage()}
        >
          Bekijk voordeel
        </div>
      </div>

      <div className="discountProgramIntro_text">
        <p>
          Zwangerenportaal.nl geeft jou niet alleen kosteloos toegang tot je
          dossier, (medische) informatievoorziening en zaken zoals
          videoconsulten en 1-op-1 Chat met je zorgverlener.{' '}
          <span>Wij gaan voor jou nu nog een stap verder.</span>
        </p>
        <p>
          Eén van de leukste dingen tijdens de zwangerschap is het shoppen voor
          de babykamer en natuurlijk de schattige babykleertjes, maar de kosten
          stapelen zich al snel op.{' '}
          <span>
            Wij helpen jou om te besparen op producten en diensten dankzij
            voordelen van hoge kwaliteit, want jouw kleintje verdient toch
            alleen het beste?
          </span>
        </p>
      </div>

      <div className="discountProgramIntro_buttons_box">
        <a
          onClick={() =>
            props.eventTrackingCodes && sendEvent(...props.eventTrackingCodes)
          }
          className="discountProgramIntro_button"
          href="/hoe-werkt-het-familie-voordeel-programma"
        >
          Meer informatie
        </a>
      </div>
    </section>
  );

  function handleClick() {
    if (!props.user.username) {
      setItem('originalUrl', '/discount-program-register');

      return props.showLoginPopup(`Wat fijn dat je lid wilt worden van
        het Familie Voordeel Programma. Log in met je account om je
        lidmaatschap aan te vragen`);
    }

    location.href = '/discount-program-register';
  }

  function scrollPage() {
    const target = document.getElementsByClassName('discountProgramBenefits');

    if (!target[0]) return;

    window.scroll({
      top: target[0].offsetTop - 165,
      behavior: 'smooth'
    });
  }
}
